import ResetPassword from './reset-password.vue';

export default ResetPassword;
